import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faPhone, faRobot, faCheck, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import {
  CheckoutContainer,
  CheckoutContent,
  ProductInfo,
  StripeBuyButtonContainer,
  PriceHighlight,
  CreditHighlight,
  PlatformRequirements,
  PlatformItem,
  SpecialHighlight,
  BonusTag,
  PlatformTitle,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceName,
  ServicePrice,
  LogoContainer,
  StripeCustomContainer,
  StripeProductName,
  StripePrice,
  StripeMonthlyText,
  StripePaymentMethods,
  StripeCustomButton,
  LeadCostNote
} from './CheckoutStyles';

const Checkout = () => {
  useEffect(() => {
    // Carrega o script do Stripe apenas uma vez quando o componente é montado
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/buy-button.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      // Limpa o script quando o componente é desmontado
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  
  // Função para lidar com o clique no botão personalizado
  const handleCustomButtonClick = () => {
    // Redirecionamento direto para a página de checkout do Stripe
    window.location.href = 'https://buy.stripe.com/14keXZaF32fg7mM28a';
  };
  
  return (
    <CheckoutContainer>
      <CheckoutContent>
        <LogoContainer>
          <img 
            src="/favicon.png" 
            alt="BIANCA Logo" 
            style={{ 
              background: 'transparent', 
              boxShadow: 'none', 
              border: 'none',
              maxWidth: '100%'
            }} 
          />
          <div className="tech-line"></div>
        </LogoContainer>
        
        <ProductInfo>
          <PriceHighlight>R$ 300,00<span>/mês</span></PriceHighlight>
          <LeadCostNote>+R$ 5,00 por lead em média</LeadCostNote>
          <BonusTag>
            <FontAwesomeIcon icon={faShieldAlt} style={{ marginRight: '8px' }} />
            BÔNUS EXCLUSIVO
          </BonusTag>
          <CreditHighlight>Ganhe R$ 200,00 em créditos na Bianca</CreditHighlight>
          
          <PlatformRequirements>
            <PlatformTitle>
            Os créditos compensam o valor a ser adicionado em plataformas externas:
            </PlatformTitle>
            
            <ServicesGrid>
              <ServiceCard>
                <ServiceIcon color="#00A67E">
                  <FontAwesomeIcon icon={faBrain} />
                </ServiceIcon>
                <ServiceName>OpenAI</ServiceName>
                <ServicePrice>US$ 5</ServicePrice>
              </ServiceCard>
              
              <ServiceCard>
                <ServiceIcon color="#F22F46">
                  <FontAwesomeIcon icon={faPhone} />
                </ServiceIcon>
                <ServiceName>Twilio</ServiceName>
                <ServicePrice>US$ 20</ServicePrice>
              </ServiceCard>
              
              <ServiceCard>
                <ServiceIcon color="#4C6EF5">
                  <FontAwesomeIcon icon={faRobot} />
                </ServiceIcon>
                <ServiceName>Vapi</ServiceName>
                <ServicePrice>US$ 10</ServicePrice>
              </ServiceCard>
            </ServicesGrid>
            
            <PlatformItem>
              <SpecialHighlight>
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '8px' }} />
                Por isso você recebe R$ 200,00 de crédito na BIANCA para compensar esse gasto!
              </SpecialHighlight>
            </PlatformItem>
          </PlatformRequirements>
        </ProductInfo>
        
        {/* Interface personalizada do Stripe */}
        <StripeCustomContainer>
          <StripeProductName>Bianca</StripeProductName>
          <StripePrice>R$ 1</StripePrice>
          <StripeMonthlyText>por mês</StripeMonthlyText>
          
          <StripeCustomButton onClick={handleCustomButtonClick}>
            Assinar
          </StripeCustomButton>
        </StripeCustomContainer>
        
        {/* Mantém o botão original do Stripe, mas oculto */}
        <div style={{ display: 'none' }}>
          <stripe-buy-button
            buy-button-id="buy_btn_1Qmh1JFqunQHKcHnxtW8sXgW"
            publishable-key="pk_live_51QQq5bFqunQHKcHnISqGbdiFEOaa4mb8GoJOqHymWtczT3x1zKMZgAER1nWzwlA2yQuR7p4PqAHkaRjW9IltLCoE00ZVj2RZxw"
          >
          </stripe-buy-button>
        </div>
      </CheckoutContent>
    </CheckoutContainer>
  );
};

export default Checkout;
